export const SOUND_URLS = {
  NOTIFICATION: {
    ANNOY: '/assets/audio/base_annoy.mp3',
    INCOMING: '/assets/audio/base_notification.mp3',
  },
} as const;
